<template>
    <div>
        <div class="address">
            <v-select @search="fetchOptions" :filterable="false" :options="search_items" v-model="calculatedCustomerAddress">
                <template slot="option" slot-scope="option">
                    <div :title="option.label">
                        {{ option.label }}
                    </div>
                </template>
                <template slot="no-options">
                    {{_T("Enter your address")}}
                </template>
            </v-select>
        </div>
        <gmap-map ref="addressMap"
                  v-bind="options"
                  @drag="centerChange"
                  id="map">
            <GmapMarker :position="marker"/>
        </gmap-map>
    </div>
</template>

<script>
    import {gmapApi} from 'vue2-google-maps';
    import {mapGetters} from 'vuex'
    import {debounce} from "../../utils/main_utils";
    import Vue from 'vue'
    import vSelect from 'vue-select'

    var do_lookup = debounce(function (that, position) {
        that.inDebounce = false
        Vue.$gmapApiPromiseLazy().then(() => {
            const geocoder = new google.maps.Geocoder()
            geocoder.geocode({location: {lat: position.lat, lng: position.lng}, language: 'en'}, (results, status) => {
                if (status === 'OK') {
                    that.results = results
                    that.customerAddress = that.results[0].formatted_address
                    that.$emit('addressFound', results[0])
                }
            })
        })
    }, 300)

    export default {
        name: "GoogleMapCustomerAddress",
        components: {
            vSelect
        },
        props:['incoming_lat_lng'],
        data() {
            return {
                options: {
                    zoom: 10,
                    center: {
                        lat: 0,
                        lng: 0
                    },
                },
                marker: {
                    lat: 0,
                    lng: 0
                },
                results: "",
                inDebounce: false,
                customerAddress: this.customerFullAddress ? this.customerFullAddress : "",
                autocomplete_service: null,
                search_items: [],
                setting_value: false,
            };
        },
        computed: {
            google: gmapApi,
            ...mapGetters([
                '_T',
                'currentCountryFullName',
                'selectedCountry',
                'customerPosition',
                'customerFullAddress',
                'isSettingAddress'
            ]),
            calculatedCustomerAddress:{
                get()
                {
                    return this.customerAddress
                },
                set(new_val)
                {
                    this.setPlace(new_val)
                }
            }
        },
        methods: {

            centerChange() {
                this.mark(this.$refs.addressMap.$mapObject.center)
            },
            fitBounds(geometry) {
                this.options.center.lat = geometry.location.lat()
                this.options.center.lng = geometry.location.lng()
                this.$refs.addressMap.fitBounds(geometry.viewport)
            },
            mark(event) {
                /* from here we can get latest let lng*/
                let lat, lng = undefined
                if (event.hasOwnProperty('latLng')) {
                    lat = event.latLng.lat()
                    lng = event.latLng.lng()
                } else {
                    lat = event.lat()
                    lng = event.lng()
                }
                this.decodeLatLong({lat, lng, force_country: true})
            },
            decodeLatLong(position) {
                this.inDebounce = true;
                var that = this
                do_lookup(that, position)
                this.marker = position
            },
            setMapByName(location) {
                this.$gmapApiPromiseLazy().then(() => {
                    const geocoder = new google.maps.Geocoder()
                    geocoder.geocode({address: location}, (results, status) => {
                        if (status === 'OK') {
                            this.fitBounds(results[0].geometry)
                            this.mark(results[0].geometry.location)
                        }
                    })
                })
            },
            fetchOptions(search, loading) {
                loading(true)
                var component = this
                if (search) {
                    this.autocomplete_service.getPlacePredictions({
                        input: search,
                        componentRestrictions: {country: this.selectedCountry}
                    }, (predictions, status) => {
                        if (status == gmapApi().maps.places.PlacesServiceStatus.OK) {
                            var results = []
                            predictions.forEach(function (prediction) {
                                results.push({
                                    'value': prediction.place_id,
                                    'label': prediction.description,
                                })
                            });
                            component.search_items = results;
                        }
                        loading(false)
                    })
                } else {
                    loading(false)
                }
            },
            setPlace(place) {
                if (place == null) {
                    this.customerAddress = null;
                } else {
                    var that = this;
                    that.setting_value = true;
                    this.places_service.getDetails({placeId: place.value}, function (results, status) {
                        if (status == gmapApi().maps.places.PlacesServiceStatus.OK) {
                            that.results = results
                            that.customerAddress = results.formatted_address;
                            that.fitBounds(results.geometry)
                            that.marker.lat = results.geometry.location.lat()
                            that.marker.lng = results.geometry.location.lng()
                            that.$emit('addressFound', results)
                        }
                        that.setting_value = false;
                    })
                }
            },
        },
        mounted() {

            var component = this;
            this.$gmapApiPromiseLazy().then(() => {
                component.$nextTick(() => {
                    var gm = gmapApi()
                    component.autocomplete_service = new gm.maps.places.AutocompleteService()
                    component.places_service = new gm.maps.places.PlacesService(document.createElement('div'))
                })
            })
            if (this.incoming_lat_lng)
            {
                this.marker = this.incoming_lat_lng
                this.options.center.lat = this.incoming_lat_lng.lat
                this.options.center.lng = this.incoming_lat_lng.lng
                this.decodeLatLong(this.incoming_lat_lng)
                this.options.zoom = 17
            }
            else if (this.customerPosition === undefined || this.customerPosition === "" || this.customerFullAddress == "") {
                this.setMapByName(this.currentCountryFullName)
            } else {
                this.marker = this.customerPosition.coordinates
                this.options.center.lat = this.customerPosition.coordinates.lat
                this.options.center.lng = this.customerPosition.coordinates.lng
                this.decodeLatLong(this.customerPosition.coordinates)
                this.options.zoom = 17
            }
        }
    };
</script>

<style lang="scss" scoped>
#map {
    height: 40vh;
    width: 100%;
    margin: 0 auto;
    margin-bottom: $px5;
}

.address {
    margin-bottom: $px5;
    min-height: 1.5rem;
}
</style>
